import { TQueries } from '@src/models/common';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import React, { useContext, useMemo } from 'react';

type IProps<T> = Partial<TQueries<React.FC<T>>> & Required<{ DESKTOP: React.FC<T> }>;

/**
 * Функция обертка для определения компонента соответствующего текущему брекпоинту
 * Обязательным параметром и минимальным является передача DESKTOP версии
 * Т.е. в случае отсутствия других, будет отдаваться именно эта версия
 *
 * @param props - объект компонентов соответсвующий своему брейкпоинту
 * @returns возвращает компонент соответствующий текущему брейкпоинту
 *
 * @example
 * export const Footer = (props: IFooterProps) =>
 *  BpWrapper<IFooterProps>(
 *    {
 *      DESKTOP: FooterDesktop,
 *      MOBILE: FooterMobile,
 *    },
 *    props,
 *  );
 * });
 */
export function BpWrapper<T>(params: IProps<T>, props: T) {
  const { breakpoint } = useContext(BreakpointsContext);

  const Component = useMemo<React.FC<T>>(() => {
    if (breakpoint && params[breakpoint]) {
      return params[breakpoint] as React.FC<T>;
    }

    return params.DESKTOP;
  }, [breakpoint, params]);

  /**
   * TODO: предпочтительней оформить wrapper так чтобы его использование было как BpWrapper(Component) без прокидывания `props`
   * Такой вариант замечательно отрабатывает на клиенте,
   * но проекты nextjs падают с ошибкой `Cannot read properties of null (reading 'useContext')`
   * Этот случай надо глубже поресерчить
   */

  //@ts-ignore
  return <Component {...props} />;
}
